/**
 * An array of strings representing all semantic daisy UI colors
 *
 * @constant
 * @type {string[]}
 */
export const semanticColors = [
  'primary',
  'brand-alt',
  'secondary',
  // 'accent',
  'neutral',
  'info',
  'success',
  'warning',
  'error',
];

/**
 * An object of strings representing the background color of an avatar by first letter of the user's initials
 *
 * @constant
 * @type {Object.<string, string>}
 */
export const AvatarColorsByInitials = Object.freeze({
  A: '#444CE7',
  B: '#00A89F',
  C: '#8288EF',
  D: '#55C5BE',
  E: '#2F35A1',
  F: '#00756F',
  G: '#1B1E5C',
  H: '#00433F',
  I: '#444CE7',
  J: '#00A89F',
  K: '#8288EF',
  L: '#55C5BE',
  M: '#2F35A1',
  N: '#00756F',
  O: '#1B1E5C',
  P: '#00433F',
  Q: '#444CE7',
  R: '#00A89F',
  S: '#8288EF',
  T: '#55C5BE',
  U: '#2F35A1',
  V: '#00756F',
  W: '#1B1E5C',
  X: '#00433F',
  Y: '#444CE7',
  Z: '#00A89F',
});
